import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 查詢帳號是否存在 Response Schema
 *
 * 0 - 不存在
 * 1 - 存在
 */
export const isAccountExistResponseSchema = z.nativeEnum(TrueFalse)

/**
 * 查詢帳號是否存在 Response
 *
 * 0 - 不存在
 * 1 - 存在
 */
export type IsAccountExistResponse = z.infer<
  typeof isAccountExistResponseSchema
>
